import LivedigitalSDKError from './LivedigitalSDKError';

class NotFoundError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE = 'Requested resource was not found';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? NotFoundError.DEFAULT_MESSAGE, errorCode ?? 'not_found', meta);
  }
}

export default NotFoundError;
